import { type ReactElement } from 'react';
import { Chip } from '@optimization/ssi-common';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import { type SelectedChartSegment } from '@/app/config/chart-segments';

export interface FiltersProperties {
  readonly selectedCustomers: string[];
  readonly selectedChassisFilters: string[];
  readonly selectedStateOfHealthSegment: SelectedChartSegment | null;
  readonly selectedCycledEnergySegment: SelectedChartSegment | null;
  readonly selectedBatteries: string[];
  readonly selectedConfigurations: string[];
  readonly selectedVehicleTypes: string[];
  readonly selectedPropulsions: string[];
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const Filters = ({
  selectedCustomers,
  selectedChassisFilters,
  selectedStateOfHealthSegment,
  selectedCycledEnergySegment,
  selectedBatteries,
  selectedConfigurations,
  selectedVehicleTypes,
  selectedPropulsions,
  updateQueryParameterValues,
}: FiltersProperties): ReactElement => (
  <>
    {selectedChassisFilters.length > 0 && (
      <Chip
        text="Chassis filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { chassisFilter: [] },
          });
        }}
      />
    )}
    {selectedBatteries.length > 0 && (
      <Chip
        text="Installed Battery filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { battery: [] },
          });
        }}
      />
    )}
    {selectedConfigurations.length > 0 && (
      <Chip
        text="Wheel Configuration filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { configuration: [] },
          });
        }}
      />
    )}
    {selectedVehicleTypes.length > 0 && (
      <Chip
        text="Chassis type filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { vehicleType: [] },
          });
        }}
      />
    )}
    {selectedPropulsions.length > 0 && (
      <Chip
        text="Propulsion filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { propulsion: [] },
          });
        }}
      />
    )}
    {selectedStateOfHealthSegment && (
      <Chip
        text="State of Health graph filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { stateOfHealthIndex: [] },
          });
        }}
      />
    )}
    {selectedCycledEnergySegment && (
      <Chip
        text="Cycled Energy graph filter"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { cycledEnergyPerKilometerIndex: [] },
          });
        }}
      />
    )}
    {selectedCustomers.length > 0 && (
      <Chip
        text="Customer Name"
        size="lg"
        icon="cross"
        checked
        onClick={() => {
          updateQueryParameterValues({
            filterKeys: { customer: [] },
          });
        }}
      />
    )}
  </>
);

export default Filters;
